export const MARK_SUGGESTION = "suggestion";
